import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, from } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AccountService } from './_services/account.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  version: string = environment.version;
  isLoggedInStream: Observable<boolean>;
  permissionsStream: Observable<any[]>;
  permissions = JSON.parse(window.localStorage.getItem('permissions'));
  isUserStream: Observable<any>;
  username: string = '';
  
  dislayBoardFlag=false;
  settingFlag = false;
  usersFlag = false;
  productFlag = false;
  vendingFlag = false;
  reportFlag = false;
  merchantFlag = false;
  salesFlag = false;
  customerRegistration = false;

  constructor(private accountService: AccountService, public router: Router) {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
      }
    });
  }

  ngOnInit(): void {
    this.isUserStream = this.accountService.userStream.asObservable();
    this.isUserStream.subscribe((data) => {
      if (data != null) {
        this.username = data;
      } else {
        this.username = window.localStorage.getItem('username');
      }
    });
    this.isLoggedInStream = this.accountService.isLoggedInStream.asObservable();
    this.permissionsStream = this.accountService.permissionsStream.asObservable();

    this.permissions = this.permissionsStream.subscribe((response) => {
      this.permissions = response;
      if (
        this.permissions.filter((v) =>
          v.permission.code.toUpperCase().includes('DISPLAY_BOARD.MENU')
        ).length != 0
      ) {
        this.dislayBoardFlag = true;
      } else {
        this.dislayBoardFlag = false;
      }
      this.permissions = response;
      if (
        this.permissions.filter((v) =>
          v.permission.code.toUpperCase().includes('SETTING.MENU')
        ).length != 0
      ) {
        this.settingFlag = true;
      } else {
        this.settingFlag = false;
      }


      if (
        this.permissions.filter((v) =>
          v.permission.code
            .toUpperCase()
            .includes('NEW_CUSTOMER_REGISTRATION.MENU')
        ).length != 0
      ) {
        this.customerRegistration = true;
      } else {
        this.customerRegistration = false;
      }



      if (
        this.permissions.filter(
          (v) =>
            v.permission.code.toUpperCase().includes('USER.MENU') ||
            v.permission.code.toUpperCase().includes('ROLE.MENU') ||
            v.permission.code.toUpperCase().includes('ROLE_PERMISSION.MENU')
        ).length != 0
      ) {
        this.usersFlag = true;
      } else {
        this.usersFlag = false;
      }

      if (
        this.permissions.filter(
          (v) =>
           
            v.permission.code.toUpperCase().includes('SETTING.MENU') ||
            v.permission.code.toUpperCase().includes('MACHINE_TYPE.MENU') ||
            v.permission.code.toUpperCase().includes('LOCATION.MENU') ||
            v.permission.code.toUpperCase().includes('COUNTRY.MENU') ||
            v.permission.code
              .toUpperCase()
              .includes('EMP_CONFIGURATION_CHANNEL_TEMPLATE.MENU') ||
            v.permission.code.toUpperCase().includes('FIRMWARE.MENU')
        ).length != 0
      ) {
        this.settingFlag = true;
      } else {
        this.settingFlag = false;
      }

      if (
        this.permissions.filter(
          (v) =>
            v.permission.code.toUpperCase().includes('DEVICE.MENU') ||
            v.permission.code.toUpperCase().includes('MACHINE.MENU')
        ).length != 0
      ) {
        this.vendingFlag = true;
      } else {
        this.vendingFlag = false;
      }

      if (
        this.permissions.filter(
          (v) =>
            v.permission.code.toUpperCase().includes('PACKAGE.MENU') ||
            v.permission.code.toUpperCase().includes('PRODUCT.MENU') ||
            v.permission.code.toUpperCase().includes('LOCATION_PRICING.MENU') ||
            v.permission.code.toUpperCase().includes('MACHINE_PRICING.MENU')
        ).length != 0
      ) {
        this.productFlag = true;
      } else {
        this.productFlag = false;
      }

      if (
        this.permissions.filter(
          (v) =>
            v.permission.code
              .toUpperCase()
              .includes('MACHINE_SUPPORT_LOG.MENU') ||
            v.permission.code.toUpperCase().includes('QR_GENERATOR.MENU') ||
            v.permission.code.toUpperCase().includes('REPORT_DESIGNER.MENU') ||
            v.permission.code.toUpperCase().includes('MONTHLY_SALES.MENU') ||
            v.permission.code.toUpperCase().includes('DAILY_SALES.MENU') ||
            v.permission.code
              .toUpperCase()
              .includes('MONTHLY_MACHINE_SALES.MENU') ||
            v.permission.code.toUpperCase().includes('DAILY_MACHINE_SALES.MENU')
        ).length != 0
      ) {
        this.reportFlag = true;
      } else {
        this.reportFlag = false;
      }

      if (
        this.permissions.filter(
          (v) =>
            v.permission.code.toUpperCase().includes('E_WALLET_SALES.MENU') ||
            v.permission.code.toUpperCase().includes('CASH_SALES.MENU')
        ).length != 0
      ) {
        this.salesFlag = true;
      } else {
        this.salesFlag = false;
      }

      if (
        this.permissions.filter((v) =>
          v.permission.code.toUpperCase().includes('MERCHANT.MENU')
        ).length != 0
      ) {
        this.merchantFlag = true;
      } else {
        this.merchantFlag = false;
      }
    });
    this.accountService.init().subscribe();
  }

  logout() {
    this.accountService
      .logout()
      .pipe(
        concatMap(() => {
          return from(this.goToLogin());
        })
      )
      .subscribe();
  }
  step = -1;

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  async goToLogin() {
    return this.router.navigate(['/login']);
  }
}
